<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex grow>
                  <h3>Upravit příspěvek</h3>
                  <br>
                  <v-layout row align-center class="mb-3">
                    <v-flex shrink>
                      <p class="my-1 mx-2">
                        Skryto
                      </p>
                    </v-flex>
                    <v-flex grow>
                      <v-switch class="my-0 mx-2" v-model="item.smazano" value input-value="0" hide-details></v-switch>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <p class="my-0 mx-2">Typ obsahu:</p>
                  <v-radio-group class="mx-2 my-0" v-model="item.content_type" row :rules="rulesRequired">
                    <v-radio label="Free" value="free"></v-radio>
                    <v-radio label="Free náhled" value="polofree"></v-radio>
                    <v-radio label="Premium" value="premium"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm8>
                  <v-text-field label="Název" v-model="item.nazev" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    class="mx-2"
                    :items="items_kategorie"
                    :rules="rulesRequired"
                    label="Vyberte kategorii"
                    item-text="nazev_kategorie"
                    v-model="item.id_kategorie"
                    item-value="id"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 class="picker-w100">
                  <datepicker label="Datum" v-model="item.datum" :rules="true" class="mx-2"></datepicker>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Autor" v-model="item.autor" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Délka videa" v-model="item.minut" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="URL" v-model="item.link" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm8>
                  <v-text-field label="Krátký popis příspěvku (SEO)" v-model="item.description" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <vue-dropzone :options="dropzoneOptions" :id="'dropzone'" :useCustomSlot="true" style="min-height: 120px;">
                    <div>
                      <div>
                        <div>
                           <v-layout row wrap>
                             <v-flex xs12 sm6 class="px-2 mb-2">
                               <v-card class="no__radius pt-0 px-2 pb-3" color="grey lighten-3" v-if="item.obrazek != null && item.obrazek.s3_nazev != null">
                                 <v-card-title class="py-2 px-0 justify-end">
                                   <v-btn color="red" flat class="ma-0" @click="removeFile(soubor)"><v-icon class="mr-2">delete</v-icon> Smazat</v-btn>
                                 </v-card-title>
                                 <v-card-text class="pa-0">
                                   <img :src="$imagesBaseUrl+item.obrazek.s3_nazev" class="edit-img">
                                 </v-card-text>
                                 <v-card-actions class="pa-0 mt-2">
                                   <p class="mb-0 caption word-break">{{item.obrazek.nazev}}</p>
                                 </v-card-actions>
                               </v-card>
                             </v-flex>
                           </v-layout>
                        </div>
                        <p class="pt-5 pb-4 text-xs-center"><v-icon class="mr-2">cloud_upload</v-icon>Nahrajte náhledový obrázek přetažením souboru z&nbsp;počítače</p>
                      </div>
                    </div>
                  </vue-dropzone>
                  <div hidden id="dropzone-preview"></div>
                </v-flex>
                <v-flex xs12 md6>
                  <v-textarea
                    class="video_code mx-2"
                    v-model="item.video"
                    label="Kód videa YouTube"
                    :rules="rulesRequired"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout wrap row>
              <v-flex xs12>
                <ContentEditor class="mt-2" v-model="item.obsah"></ContentEditor>
              </v-flex>
              <v-flex xs12 sm6></v-flex>
              <v-flex xs12 sm6 class="text-right">
                <router-link :to="{ path: '/videoblog/prispevky/' }">
                  <v-btn color="grey lighten-3 elevation-0">Zpět na výpis</v-btn>
                </router-link>
                <v-btn color="blue darken-3 elevation-0" dark @click="editPost();" :loading="sending">Uložit</v-btn>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import ContentEditor from '@/components/ContentEditor'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import draggable from 'vuedraggable'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      sending: false,
      valid: true,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      item: {},
      items_kategorie: [],
      dropzoneOptions: null,
      obrazky: []
    }
  },
  props: {
    id: String,
  },
  mounted: function() {
    var $this = this;
    this.dropzoneOptions = {
      url: window.API.$api_url+"uploader/file",
      clickable: false,
      autoProcessQueue: true,
      uploadMultiple: false,
      parallelUploads: 1,
      addRemoveLinks: true,
      previewsContainer: "#dropzone-preview",
      headers: {
        "AuthToken": window.api.$cookies.get("cc_com_token")
      },
      init: function() {
        this.on("addedfile", function(a, b, c) {
          $this.uploading = true;
        }.bind(this));
        this.on("success", function(a, b, c) {
          if (b.uploaded) {
            $this.item.obrazek = ({
              id: b.id,
              nazev: a.name,
              s3_nazev: b.s3_name
            });
          }
        }.bind(this));
      }
    };
    this.getCategories(() => {
      this.load();
    });
  },
  methods: {
    load: function(v) {
      window.api.get("videoblog/prispevky/" + this.$props.id).then(function(_body) {
        this.item = _body;
        this.loadingTable = false;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    getCategories (f) {
      window.api.get("videoblog/kategorie/all").then(function(_body) {
        this.items_kategorie = _body;
        if (typeof f == "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    editPost () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.put("videoblog/prispevky/"+this.$props.id, this.item).then(function(body) {
          this.sending = false;
          this.loading = true;
          this.load();
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    }
  },
  components: {
    ContentEditor,
    vueDropzone: vue2Dropzone, draggable
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/VideoBlog/VideoBlogPrispevkyDetail.vue